import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import { Helmet } from 'react-helmet-async';
import { NEWS_LIST_GET } from '../../redux/actions/news';
import CardNews from '../../../ui/atoms/Cards/CardNews';
import routes from '../../../routes';
import { NoResult, Text } from '../../../ui/atoms';
import { FiltersWrapper, NewsGrid, NewsCarouselWrapper } from './style';
import { Container } from '../../../ui/gridSystem';
import Pagination from '../../../ui/atoms/Pagination';
import { CustomCarousel } from '../../../ui/components';
import { Settings } from './settings';
import { HOME_NEWS_LIST_GET } from '../../redux/actions/home';
// import { getFilterLabel } from '../../../utils/labels';
import SortBy from '../../../ui/atoms/SortBy';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { isPublicPath } from '../../../utils/common';
import { feBaseUrl } from '../../api/config';
import {
  getPageDescriptionByPath,
  getPageTitleByPath,
} from '../../../utils/labels';

const News = ({
  mediaIsPhone,
  filters,
  list,
  getNews,
  pager,
  getMainNews,
  mainNews,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selectedFilters, setSelectedFilters] = useState({});
  const isPublic = () => isPublicPath(pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
    getMainNews(isPublic());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetNews = (page) => {
    const newFilters = { ...selectedFilters, page };
    getNews({ filters: newFilters }, isPublic());
  };

  useEffect(() => {
    handleGetNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  // const onClickSearch = () => {
  //   setSelectedFilters({ ...selectedFilters, title: searchValue });
  // };

  const loadMore = (page) => handleGetNews(page);
  const setItemsPerPage = (v) => {
    handleOnChange({ key: 'items_per_page', value: v });
  };

  const onClickNews = (id) => {
    if (isPublic()) navigate(`${routes.publicNewsDetails.path}/${id}`);
    else navigate(`${routes.newsDetails.path}/${id}`);
  };

  return (
    <>
      {isPublic() && (
        <Helmet>
          <title>{getPageTitleByPath(pathname)}</title>
          <link rel="canonical" href={`${feBaseUrl}${pathname}`} />
          <meta
            name="description"
            content={getPageDescriptionByPath(pathname)}
          />
        </Helmet>
      )}
      <Container>
        <Text type="h1" mb={32}>
          Comunicazione
        </Text>
      </Container>
      {mainNews?.length > 0 && (
        <NewsCarouselWrapper>
          <CustomCarousel config={Settings}>
            {(mainNews || []).map((item) => (
              <CardNews
                item={item}
                key={`news-${item?.id}`}
                onClick={() => onClickNews(item?.id)}
              />
            ))}
          </CustomCarousel>
        </NewsCarouselWrapper>
      )}
      <Container>
        <FiltersWrapper>
          {/*<SelectWrapper>
              <CustomInput
                placeholder="Cosa vuoi cercare?..."
                isSearch
                value=""
                icon="search-sm"
                isClearable
                onChange={(value) => setSearchValue(value)}
                onClickIcon={onClickSearch}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') onClickSearch();
                }}
              />
            </SelectWrapper>*/}
          {/*{(Object.keys(filters) || []).map((key, i) => (
              <SelectWrapper key={`filter-${i}`}>
                <CustomSelect
                  placeholder={getFilterLabel(key)}
                  options={filters[key].map((opt) => formatFilterOpt(opt))}
                  onChange={(value) => handleOnChange({ key, value })}
                  isClearable
                />
              </SelectWrapper>
                ))}*/}
          <SortBy
            onChange={(value) => {
              handleOnChange({ key: 'sort_by', value });
            }}
          />
        </FiltersWrapper>
        {list?.length > 0 ? (
          <>
            <NewsGrid>
              {(list || []).map((item) => (
                <CardNews
                  item={item}
                  key={`news-${item?.id}`}
                  onClick={() => onClickNews(item?.id)}
                  className={mediaIsPhone ? '' : 'large'}
                />
              ))}
            </NewsGrid>
            <Pagination
              pager={pager}
              callBack={loadMore}
              setItemsPerPage={setItemsPerPage}
            />
          </>
        ) : (
          <NoResult />
        )}
      </Container>
    </>
  );
};

News.propTypes = {
  mediaIsPhone: PropTypes.bool,
  //HOC (connect, state)
  filters: PropTypes.object,
  list: PropTypes.array,
  mainNews: PropTypes.array,
  pager: PropTypes.object,

  //HOC (connect, dispatch)
  getMainNews: PropTypes.func,
  getNews: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { list, filters, pager } = state.news;
      const { news: mainNews } = state.home;
      return {
        filters,
        list,
        mainNews,
        pager,
      };
    },
    (dispatch) => ({
      getNews: ({ filters }, isPublic) =>
        dispatch({ type: NEWS_LIST_GET._REQUEST, filters, isPublic }),
      getMainNews: (isPublic) =>
        dispatch({ type: HOME_NEWS_LIST_GET._REQUEST, isPublic }),
    })
  ),
  withMediaQueries
)(News);
